import {
  PrintOptionDto,
  QuantityPerColorStepDto,
  QuantityPerSizePerColorStepDto,
  QuantityPerSizeStepDto,
  QuantityPerVariantStepDto,
  QuantityStepDto,
} from '@/api-sdk';

export type ColorOption = {
  image?: string;
  name: string;
  selected: boolean;
  queryString: string;
};

export type ColorOptions = ColorOption[];

export type VersionOption = {
  name: string;
  selected: boolean;
  queryString: string;
};

export type VersionOptions = VersionOption[];

export type PrintOptionFilterOption = {
  name: string;
  image: string;
  description?: string;
  queryString: string;
};

export type PrintOptions = PrintOptionDto[];

export type PrintOptionFilterOptions = PrintOptionFilterOption[];

export type QuantityOption = {
  quantity: number;
  price: string;
  discountPercentage: number;
  totalPrice: string;
  isStartingPrice: boolean;
  selected: boolean;
  queryString: string;
};

export type QuantityOptions = QuantityOption[];

export type QuantityPerColorOption = {
  color: string;
  price: string;
  quantity: number;
  totalPrice: string;
  image: string;
  queryString: string;
};

export type QuantityPerColorOptions = QuantityPerColorOption[];

export type QuantityPerSizeOption = {
  price: string;
  quantity: number;
  size: string;
  totalPrice: string;
  queryString: string;
};

export type QuantityPerSizeOptions = QuantityPerSizeOption[];

export type QuantityPerSizeColorColor = {
  color: string;
  image: string;
};

export type QuantityPerSizeColorColors = QuantityPerSizeColorColor[];

export type QuantityPerSizeColorOptionQuantity = {
  value: number;
  queryString: string;
};

export type QuantityPerSizeColorOption = {
  quantities: QuantityPerSizeColorOptionQuantity[];
  price: string;
  size: string;
  isStartingPrice: boolean;
};

export type QuantityPerSizeColorOptions = QuantityPerSizeColorOption[];

export type StepSelectMode = 'single' | 'multi';

type StepType =
  | 'color'
  | 'color_version'
  | 'version'
  | 'print_option'
  | 'quantity'
  | 'quantity_per_color'
  | 'quantity_per_size'
  | 'quantity_per_size_color';

type FilterOptionsType = 'position' | 'colors' | 'submitLogo';

export type Step = {
  type: StepType;
  selectMode?: StepSelectMode;
  options?: ColorOptions | VersionOptions | PrintOptions;
  colorOptions?: ColorOptions;
  versionOptions?: VersionOptions;
  filterOptionsType?: FilterOptionsType;
  filterOptions?: PrintOptionFilterOptions;
  filterQuestion?: string;
  description?: string;
  cancelQueryString?: string;
};

export type QuantitySteps =
  | 'quantity'
  | 'quantity_per_color'
  | 'quantity_per_size'
  | 'quantity_per_size_color';

export type Steps = Step[];

export type QuantityData =
  | QuantityStepDto
  | QuantityPerColorStepDto
  | QuantityPerSizeStepDto
  | QuantityPerSizePerColorStepDto
  | QuantityPerVariantStepDto;

export type LayoutType = 'retail' | 'wholesale';

export type SummaryData = {
  colorCount: number | null | undefined;
  image: string | null | undefined;
  dimensions: string | null | undefined;
  printMethod: string | null | undefined;
  printPosition: string;
};

export enum Mode {
  DEFAULT = 'default',
  QUOTE = 'quote',
  DIGITAL_EXAMPLE = 'digital-example',
}

export enum Variant {
  DEFAULT = 'default',
  SIMPLE = 'simple',
}

export enum DateType {
  SHIPPING = 'shipping',
  DELIVERY = 'delivery',
}
